import DeleteSequenceNumberRequestModelBase from '../_generated/modelBases/delete-sequence-number-request-model-base';

export default class DeleteSequenceNumberRequestModel extends DeleteSequenceNumberRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
